<template>
    <div id="PDFview">
        <div class="text_option txt1">
            <h3 >Informe de Prueba</h3>
        </div>
        <div class="">
            <div class="pdfv">
               <PDFcreate_B />
                <div class="btnsPDF">
                    <div class="boxbtn">
                        <button @click="wait()" class="inicio">Inicio</button>
                    </div>
                    <div class="boxbtn">
                        <button @click="changeView('Resultados',added)" class="modificar">Modificar</button>
                    </div>
                    
                    <div class="boxbtn">
                        <button @click="validar(added, identity)" class="validar">Confirmar</button>
                    </div>
                </div>
            </div>
            

        </div>


          <div v-if="status !=''" class="status_messages">
                            <div v-if="status =='success'" class="msg msg_success">
                                 <p>{{message}}</p>
                            </div>
                            <div  v-if="status =='error'" class="msg msg_error">
                                <p>{{message}}</p>
                            </div>
            </div>



         <div v-if="viewModal" class="modal_view"> 
           
              <div id="modal_val">
            <p @click="closeModal()" class="close_modal"> &#215;</p>
            <h3 class="title_val"> <span>Validación</span> exitosa</h3>
           
            <div class="modal_val_btns dflx">
                 <p  @click="back()" >ACEPTAR</p>
            </div>
          </div>
        </div> 
       
       
    </div>
</template>
<script>



import {mapActions} from 'vuex';
import dayjs from 'dayjs';
import PDFcreate_B from '../../components/barragan/PDFcreate_B.vue';

export default {
    name:'PDFview',
    data(){
        return{
            status:'',
            message:'',
            item: '',
            viewModal:false,
            texto:'',
            texdos:'',
        }
    },
    components:{
        PDFcreate_B
    },
    async created(){
        this.getIdentity()
         
        
    },
    computed:{
        added(){
                    return this.$store.getters["validaciones/getAdded"]
        },
         identity() {
             return this.$store.getters['admin/getIdentity'];
       }
    },

    methods: {
        ...mapActions('validaciones', ['setHistoryOptionVal']),
        ...mapActions('validaciones', ['setAddedVal']),
        ...mapActions('texto', ['getAllInfoTxt']),
        ...mapActions('texto', ['addItemTxt']),
            
        getIdentity: async function (){
          let response =  await this.$store.dispatch("admin/getData");
          return response
        },
         showModal: function(){
          
             this.viewModal=true
         },
        
         closeModal:function(){
             this.viewModal=false;
             this.mtra ='';
         },
        wait: function(){
            setTimeout(() => this.$router.go(), 200);
        },
         back:function(){
        setTimeout(() => this.$router.go(), 200);
        },
        delStatus: function () {
            setTimeout(() => this.delMsgs()
            ,2000);
           /* setTimeout(() => this.wait()
            ,500); */
            
        },
        delMsgs: function(){
            this.status=""
            this.message=""
        },

         changeView(option, item){
             this.item=item
             this.setAddedVal(item)
             this.setHistoryOptionVal(option)
         },

         validar: async function (muestra, admin){
            console.log(muestra, admin)

              if(admin != undefined && muestra != undefined){
                        /** hacemos el update de la firma del analista */
                       
                            let data ={
                                id:muestra.id,
                                superviso: admin.ini
                            }

                  

                            let result = await this.$store.dispatch("validaciones/editItemVal",  {option:'muestras_b/fs', item: data});
                                            
                            if(result.status=='error' ){
                                this.status='error'
                                this.message= result.message
                                this.delStatus();
                            }else{ // success
                                    this.showModal();
                            }
                       
                }
           
         }
    },
}
</script>
<style scoped>
        .text_option h3{
   
    margin-top: 0vw;
    font-size: 1.8229166666666667VW;
    color: var(--color-4);
    font-weight: 300 !important;
    font-style: normal;
    margin-bottom: 2.083333333333333VW;
  }
        .txt1{
            margin-bottom: 1.6145833333333335VW;
        }



        .pdfv{
            width: 100%;
            height: fit-content;
            margin-right: 2.1354166666666665VW;
        }

         button.modificar, button.inicio{
        background:#868686 ;
        color: white;
        border: none;
        width: 10.15625VW;
        height: 2.2916666666666665VW;
        margin-top:  0vw;
        margin-bottom: 0.5729166666666666VW;
         
    }

     button.validar{
        background:#007E94 ;
        color: white;
        border: none;
        width: 10.15625VW;
        height: 2.2916666666666665VW;
        margin-top: 0vw
    }
    .btnsPDF{
        display: flex;
        margin-top: 1vw;
    }
    .boxbtn{
        width: 11vw;
    }

       
</style>